module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/usb-7a2f3ff3235113bf003642b4bc9ebc1b.svg";